import { observer } from 'mobx-react-lite'
import { NotifyProsOfUnclaimedJobsDialog } from '@/features/jobs/list/components/JobManagement/NotifyProsOfUnclaimedJobsDialog'
import { type NotifyProsOfUnclaimedJobsDialogViewModel } from './NotifyProsOfUnclaimedJobsDialogViewModel'

export interface NotifyProsOfUnclaimedJobsDialogContainerProps {
  vm: NotifyProsOfUnclaimedJobsDialogViewModel
}

export const NotifyProsOfUnclaimedJobsDialogContainer = observer(
  function NotifyProsOfUnclaimedJobsDialogContainer({
    vm,
  }: NotifyProsOfUnclaimedJobsDialogContainerProps) {
    return (
      <NotifyProsOfUnclaimedJobsDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        onNotifyPros={vm.notifyPros}
        isNotifyPending={vm.notifyPros.pending}
      />
    )
  },
)
